export const DIM_OPACITY = 0.3;

export const resolveItemOpacity = (index: number, selectedIndex: number | null | undefined): number =>
  typeof selectedIndex === 'number' && selectedIndex >= 0 && index !== selectedIndex ? DIM_OPACITY : 1;
